import * as React from 'react'
import * as moment from 'moment'
import styled from 'styled-components'
import { COLORS } from '../../../../../static/constants'
import SvgIcon from '../../../../atoms/SvgIcon'
import { Tooltip } from '../../../../atoms/Tooltip'

// 日本時間のUTCオフセット。OPの端末のタイムゾーンに依存せずJSTで表示するために使用する
const JST_OFFSET = 9

interface IProps {
  arrivedAt: string | null
}

// ガイド到着状態を示す読み取り専用インジケーター。到着済の場合はJSTの到着時刻を表示する
export const GuideArrivalBadge = ({ arrivedAt }: IProps) => {
  const arrived = !!arrivedAt
  const arrivedAtJst = arrived ? moment(arrivedAt).utcOffset(JST_OFFSET) : null
  const indicator = (
    <Indicator arrived={arrived} aria-label={arrived ? 'ガイド到着済' : 'ガイド到着未'}>
      <SvgIcon
        name={arrived ? 'check_circle_filled' : 'radio_button_unchecked'}
        className="icon"
        ariaHidden={true}
        role="presentation"
        width={14}
        height={14}
      />
      <span>ガイド到着</span>
      {arrivedAtJst && <time dateTime={arrivedAtJst.format()}>{arrivedAtJst.format('HH:mm')}</time>}
    </Indicator>
  )
  if (!arrivedAtJst) {
    return indicator
  }
  // native title は再レンダリングで表示が不安定になるため、CSSホバーのTooltipでバッジ全体を対象にする
  return <Tooltip content={arrivedAtJst.format('YYYY-MM-DD HH:mm:ss')}>{indicator}</Tooltip>
}

const Indicator = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  flex: none;
  cursor: default;

  font-size: 11px;
  line-height: 1.6rem;
  color: ${props => (props.arrived ? COLORS.successText : COLORS.subText)};

  .icon {
    flex: none;
    fill: ${props => (props.arrived ? COLORS.success : COLORS.disabled)};
  }

  time {
    font-weight: 700;
  }
`
